import React from 'react';
import HelicopterGame from '../components/HelicopterGame';
import styles from './HelicopterPage.module.css';

const HelicopterPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Helicopter</h1>
      <div className={styles.gameContainer}>
        <HelicopterGame />
      </div>
    </div>
  );
};

export default HelicopterPage; 